<template>
  <div>
    <div class="card-action-box" role="button" :aria-label="read ? 'Marcar colaboração como não lida' : 'Marcar colaboração como lida'" @click="handleClick">
      <v-tooltip v-if="!isAtMosaicoView" left color="surface_neutral_selected">
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            class="mark-as-read-icon"
            v-bind="attrs"
            v-on="on"
            :color="isAtCardMosaico ? iconColor : read ? 'primary' : 'icon_default'"
          >
            mdi-check-all
          </v-icon>
        </template>
        <span :style="{ color: $vuetify.theme.dark ? 'white' : 'black' }">
          {{ read ? "Marcar colaboração como não lida" : "Marcar colaboração como lida" }}
        </span>
      </v-tooltip>
      <v-icon
        v-else
        :color="isAtCardMosaico ? iconColor : read ? 'primary' : 'icon_default'"
      >
        mdi-check-all
      </v-icon>
    </div>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";

export default {
  props: {
    isAtMosaicoView: {
      type: Boolean,
      default: false,
    },
    colabData: Object,
    num_coluna_telao: Number,
    pageModerada: Number,
    getColaboracoesModeradas: Function,
    isAtCardMosaico: {
      type: Boolean,
      default: false,
    },
    iconColor: {
      type: String,
      default: "#FFF",
    },
  },
  data() {
    return {
      read: Boolean(this.colabData.flg_colaboracao_lida),
    };
  },
  methods: {
    async handleClick() {
      this.read = !this.read;
      await apiClient
        .patch(
          `/atualizarFlagColaboracaoLida/${this.colabData.cod_producao}/${this.colabData.id_colaboracao}`,
          {
            flg_colaboracao_lida: this.read,
          }
        )
        .catch((error) => {
          console.error(error);
          this.$toast.error("Erro ao tentar marcar colaboração como lida");
        });
      if (!this.isAtCardMosaico) {
        await this.getColaboracoesModeradas({
          num_coluna_telao: this.num_coluna_telao,
          page: this.pageModerada,
          size: 5,
          cod_producao: this.colabData.cod_producao,
          filtro_texto_moderada: "",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
